import { matchPath } from 'react-router';
import { routes } from '~/routes';
import {
  ICancellationSurveyOrigin,
  TCancellationSurveyExit,
} from '../types/CancellationSurveyOrigin';

/** A shift's own pages, skipped on the way back like mobile's `SHIFT_PAGE_ROUTES`. */
export const SHIFT_PAGE_ROUTES: readonly string[] = [
  routes.openJobDetails,
  routes.jobDetails,
  routes.confirmCandidate,
];

const pageLoadNonce = Math.random().toString(36).slice(2);
export const CANCELLATION_SURVEY_PAGE_LOAD_ID = `${Date.now()}-${pageLoadNonce}`;

/**
 * Mirrors mobile's `getSurveyExitAction`: back past the survey, and past the shift page too when
 * the cancel started there. Earlier entries' URLs can't be read, so only the one shift page is skipped.
 */
export const getCancellationSurveyExit = (
  origin?: Partial<ICancellationSurveyOrigin> | null,
  pageLoadId: string = CANCELLATION_SURVEY_PAGE_LOAD_ID,
): TCancellationSurveyExit => {
  if (typeof origin?.pathname !== 'string' || origin.pageLoadId !== pageLoadId) {
    return { to: routes.dashboardHome };
  }

  const { pathname, historyIndex } = origin;
  if (!SHIFT_PAGE_ROUTES.some((route) => matchPath(route, pathname))) return { delta: -1 };

  // A shift page at index 0 was opened directly, so going back two would leave the app.
  return typeof historyIndex === 'number' && historyIndex > 0
    ? { delta: -2 }
    : { to: routes.dashboardHome };
};
